import axios from "axios";
import { Toast } from "../../util/Toast";
import { GET_DAILY_TASK_REWARDS, UPDATE_DAILY_TASK_REWARDS } from "./types";

export const getDailyTaskRewards = () => (dispatch) =>
  axios
    .get("dailyTask/admin")
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: GET_DAILY_TASK_REWARDS, payload: res.data.data });
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) =>
      Toast("error", error.response?.data?.message || error.message),
    );

export const updateDailyTaskRewards = (taskId, points) => (dispatch) =>
  axios
    .put(`dailyTask/admin/${taskId}/points`, { points })
    .then((res) => {
      if (res.data.status) {
        dispatch({ type: UPDATE_DAILY_TASK_REWARDS, payload: res.data.data });
        Toast("success", "Vibe Pass task points updated");
        return true;
      }
      Toast("error", res.data.message);
      return false;
    })
    .catch((error) => {
      Toast("error", error.response?.data?.message || error.message);
      return false;
    });
